import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {COUNTRY_MESSAGES, PHONE_COUNTRIES} from '../constants'

/**
 * Returns phone countries ordered by their localized names.
 *
 * @example
 * const phoneCountries = useSortedPhoneCountries()
 *
 * @returns {Array<object>} phone countries ordered by localized country name
 */
export const useSortedPhoneCountries = () => {
    const {formatMessage} = useIntl()

    return useMemo(
        () =>
            PHONE_COUNTRIES.map((phoneCountry) => ({
                phoneCountry,
                countryName: formatMessage(COUNTRY_MESSAGES[phoneCountry.countryCode])
            }))
                .sort(
                    (first, second) =>
                        first.countryName.localeCompare(second.countryName) ||
                        first.phoneCountry.countryCode.localeCompare(
                            second.phoneCountry.countryCode
                        )
                )
                .map(({phoneCountry}) => phoneCountry),
        [formatMessage]
    )
}
